import request from '@/router/axios'
export function fetchList(query) {
  return request({
    url: '/platformWorker/',
    method: 'post',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/platformUser/insert',
    method: 'post',
    params: obj
  })
}

export function dictionary(obj) {
  return request({
    url: '/dict/getWxMiniAppDicts',
    method: 'post',
    params: obj
  })
}

export function getObj(query) {
  return request({
    url: '/platformWorker/info',
    method: 'post',
    params: query
  })
}

export function getpersonnel(query) {
  return request({
    url: '/platformCompany/userInfo',
    method: 'post',
    params: query
  })
}

//删除工人
export function deleteWorker(query) {
  return request({
    url: '/platformWorker/deleteWorker',
    method: 'post',
    params: query
  })
}

//删除企业员工
export function deletepersonnel(query) {
  return request({
    url: '/platformUser/deleteUser',
    method: 'post',
    params: query
  })
}

export function getworkerObj(query) {
  return request({
    url: '/user/getWorkerInfo',
    method: 'post',
    params: query
  })
}


export function getCompanyWorkers(query) {
  return request({
    url: '/manager/companyWorker/',
    method: 'post',
    params: query
  })
}


export function getCompanyWorkerInfo(query) {
  return request({
    url: '/manager/companyWorker/info',
    method: 'post',
    params: query
  })
}

// export function delObj(id) {
//   return request({
//     url: '/admin/user/' + id,
//     method: 'delete'
//   })
// }

export function putObj(obj) {
  return request({
    url: '/platformUser/update',
    method: 'post',
    params: obj
  })
}

// 获取所有角色
export function roleList(query) {
  return request({
    url: '/role/rolePage',
    method: 'post',
    params: query
  })
}

// 停用
export function stop(query) {
    return request({
      url: '/platformWorker/updateStatus',
      method: 'post',
      params: query
    })
  }

  // 停用
export function changePwd(query) {
  return request({
    url: '/platformWorker/updateStatus',
    method: 'post',
    params: query
  })
}

//新增修改企业员工
export function insertOrUpdateUser(query) {
  return request({
    url: '/platformCompany/insertOrUpdateUser',
    method: 'post',
    params: query
  })
}

//获取管理员转让验证码
export function setcodephone(query) {
  return request({
    url: '/phone/send',
    method: 'post',
    params: query
  })
}
//获取管理员记录
export function getAdminLog(query) {
  return request({
    url: '/transferAdmin/getAdminLog',
    method: 'post',
    params: query
  })
}

//获取黑名单信息
export function getblack(query) {
  return request({
    url: '/companyBlackWorker/getWorkerInCompanysBlack',
    method: 'post',
    params: query
  })
}


//管理员手机验证
export function Adminchengphone(query) {
  return request({
    url: '/transferAdmin/validate',
    method: 'post',
    params: query
  })
}

//管理员转化操作
export function changerole(query) {
  return request({
    url: '/transferAdmin/transfer',
    method: 'post',
    params: query
  })
}


export function blackWorkerList(query) {
  return request({
    url: '/companyBlackWorker/',
    method: 'post',
    params: query
  })
}

export function addBlack(query) {
  return request({
    url: '/companyBlackWorker/add',
    method: 'post',
    params: query
  })
}

export function removeBlack(query) {
  return request({
    url: '/companyBlackWorker/remove',
    method: 'post',
    params: query
  })
}

export function getMyWorkerInfo(query) {
  return request({
    url: '/user/getMyWorkerInfo',
    method: 'post',
    params: query
  })
}


